import React, { Component } from 'react';

class Formatter extends Component {
  render() {
    let value = (this.props.value != undefined ? this.props.value : '').toLocaleString(navigator.language, {
      maximumFractionDigits: this.props.places || 2, minimumFractionDigits: this.props.places || 2
    });
    return (
      <span className={this.props.textLeft == true ? '' : 'float-right'}>{value + ' %'}</span>
    );
  }
}

export default Formatter;
